"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMediaAutoplayGallery = void 0;
const react_1 = __importStar(require("react"));
const fdr_regular_fusion_fdr_media_1 = require("@hotelplan/fdr.regular.fusion.fdr-media");
const fdr_media_autoplay_gallery_styles_1 = require("./fdr-media-autoplay-gallery.styles");
const fdr_media_autoplay_gallery_types_1 = require("./fdr-media-autoplay-gallery.types");
function filterOutItems(typename, items) {
    switch (typename) {
        case fdr_media_autoplay_gallery_types_1.EMediaGalleryPlacement.Gallery: {
            return items;
        }
        case fdr_media_autoplay_gallery_types_1.EMediaGalleryPlacement.Hero: {
            return items === null || items === void 0 ? void 0 : items.filter(item => ['FdrImage', 'FdrVideo'].includes(item.__typename));
        }
        default:
            return [];
    }
}
function renderMediaItem(fullScreen, loop, muted, imageElement, previewImage) {
    return function Switch(item, index, { visible }, auto) {
        switch (item.__typename) {
            case 'FdrImage':
                return imageElement ? (imageElement({
                    key: index,
                    image: item,
                    lazy: index !== 0,
                })) : (react_1.default.createElement(fdr_regular_fusion_fdr_media_1.FdrMediaImage, { key: index, image: item, lazy: index !== 0 }));
            case 'FdrVideo':
                return (react_1.default.createElement(fdr_regular_fusion_fdr_media_1.FdrMediaVideo, { key: `video-${index}`, active: visible, preview: item.preview, resource: item.resourceLink.url, lazy: index !== 0, onPlay: auto.stop, onEnded: auto.trigger, loop: loop, muted: muted, fullScreen: fullScreen, previewImage: previewImage }));
            case 'FdrAudio':
                return (react_1.default.createElement(fdr_regular_fusion_fdr_media_1.FdrMediaVideo, { className: "music", key: `music-${index}`, active: visible, playing: false, muted: false, preview: item.preview, resource: item.resourceLink.url, lazy: index !== 0, interactive: true, onPlay: auto.stop, onEnded: auto.trigger, "data-id": "music-media" }));
            case 'FdrPdf':
                return (react_1.default.createElement(fdr_regular_fusion_fdr_media_1.FdrExternalMedia, { className: "pdf", preview: item.preview, resource: item.link.url, "data-id": "pdf-media" }));
            case 'FdrExternalMedia':
                return (react_1.default.createElement(fdr_regular_fusion_fdr_media_1.FdrExternalMedia, { className: "pdf", preview: item.preview, resource: item.resourceLink.url, "data-id": "pdf-media" }));
            default:
                return null;
        }
    };
}
function FdrMediaAutoplayGallery(_a) {
    var { mediaItems, ratio = 0.5, sliding = false, chevrons = false, autoSlide = 7000, placement = fdr_media_autoplay_gallery_types_1.EMediaGalleryPlacement.Gallery, imageElement, previewImage, fullScreen, loop, muted } = _a, carouselProps = __rest(_a, ["mediaItems", "ratio", "sliding", "chevrons", "autoSlide", "placement", "imageElement", "previewImage", "fullScreen", "loop", "muted"]);
    const renderedItems = (0, react_1.useMemo)(() => filterOutItems(placement, mediaItems), [
        placement,
        mediaItems,
    ]);
    const renderItem = (0, react_1.useMemo)(() => renderMediaItem(fullScreen, loop, muted, imageElement, previewImage), [fullScreen, loop, muted, imageElement, previewImage]);
    const isHeroPlacement = placement === fdr_media_autoplay_gallery_types_1.EMediaGalleryPlacement.Hero;
    const Carousel = isHeroPlacement ? fdr_media_autoplay_gallery_styles_1.HeroCarousel : fdr_media_autoplay_gallery_styles_1.GalleryCarousel;
    return (react_1.default.createElement(Carousel, Object.assign({ sliding: sliding, ratio: ratio, chevrons: chevrons, autoSlide: autoSlide }, carouselProps, { items: renderedItems, renderItem: renderItem })));
}
exports.FdrMediaAutoplayGallery = FdrMediaAutoplayGallery;
//# sourceMappingURL=fdr-media-autoplay-gallery.js.map